export default __webpack_public_path__ + "static/media/Bip unit icon.4958581c.svg";